import type { AppEnvironment } from "@shared/platform/feature-flags";

export function getCurrentAppEnvironment(): AppEnvironment {
  const appEnvBakedInByBuild = process.env.APP_ENV;
  return appEnvBakedInByBuild === "trial" || appEnvBakedInByBuild === "production" ? appEnvBakedInByBuild : "development";
}
